import { SectionsKey } from '~/constants/enum';

const PageStruct = {
    id: 'delivery-addresses',
    useLayout: true,
    children: [{ id: 'delivery-addresses', order: 1, dataKey: SectionsKey.DeliveryAddresses }]
};

export default PageStruct;
